// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1VIdK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Gwww"};